import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function FadeIn({
  children,
  className = '',
  delay = 0
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-208">
      {children}
    </motion.div>;
}